<div class="height-100 bg-col-w">
    <div class="flex-column height-100">
        <div class="flex flex-middle flex-justify-between p-a-5 p-a-4-s b-b b-col-5">
            <h6 class="h3">
                {{modalTitle || ''}}
            </h6>

            <button role="button"
                    aria-label="Close"
                    (click)="close()"
                    class="inline-flex">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>

        <div class="overflow-auto custom-scrollbar flex-grow p-r-4-s p-l-4-s">
            <ng-content select="[modalBody]" />
        </div>

        <div class="w-12 modal-footer p-a-3 p-l-5 p-r-5 p-r-4-s p-l-4-s">
            <ng-content select="[modalFooter]" />
        </div>
    </div>
</div>